module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor06-cd662314b7eaf54a40d3d00976536ddc.jpg";